import logger from '../../log';
import { PossibleIceCandidate } from '../../priming/interfaces';
import { isString } from '../../common/utils/stringify';

const log = logger.getLogger(__filename);

/**
 * Parses potential ice candidates into RTCIceCandidates.
 * Protects against being passed actual candidates, a single string, array of
 * strings, or JSON representations of RTCIceCandidates
 * See: https://developer.mozilla.org/en-US/docs/Web/API/RTCIceCandidate
 */
const toIceCandidates = (items?: PossibleIceCandidate[]): RTCIceCandidate[] => {
  if (!items) {
    return [];
  }
  if (!(items instanceof Array)) {
    try {
      items = JSON.parse(items);
    } catch (e) {
      log.info('Passed unparsable possible RTCIceCandidates', items);
      return [];
    }
  }
  if (!(items instanceof Array)) {
    return [];
  }
  return items
    .map(item => {
      try {
        if (item instanceof RTCIceCandidate) {
          return item;
        }
        const candidate = isString(item) ? JSON.parse(item) : item;
        if (candidate?.candidate) {
          return new RTCIceCandidate(candidate as RTCIceCandidateInit);
        }
      } catch (e) {
        log.info('Unable to parse RTCIceCandidate:', item);
      }
      return null;
    })
    .filter(i => !!i) as RTCIceCandidate[];
};

export default toIceCandidates;
